import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { aggregateFollowersCount } from '../helpers';

class FollowersByDateSidebar extends PureComponent {
    static propTypes = {
        lastNFollowers: PropTypes.array.isRequired,
        lastNDays: PropTypes.number,
        noFollowers: PropTypes.number,
    };

    render() {
        const lastNFollowersCount = aggregateFollowersCount(
            this.props.lastNFollowers
        );

        return (
            <div className="panel">
                <h3>Siste {this.props.lastNDays} dager</h3>
                <p>
                    Nye følgere:
                    <span className="u-float-right">{lastNFollowersCount}</span>
                </p>
                <p className="btt u-pt8">
                    Deres følgere totalt:
                    <span className="u-float-right">
                        {this.props.noFollowers}
                    </span>
                </p>
            </div>
        );
    }
}

export default FollowersByDateSidebar;
